export default "__VITE_ASSET__CLmGHgTl__"